<template>

    <div id="slider">
        <div class="slider">
            <!-- <div class="slides" :style="{left:-width*current+'vw'}"> -->
                <div class="slides" :style="widthTransform">
                <div v-for="slide in slides">
                    <figure class="theslides">

                        <img  v-if="slide.slide_image.includes('jpg')" :src=" url + '/' + slide.slide_image" alt="">
                        <!-- <div v-if="slide.slide_image.includes('mov')" class="mute-toggle" :class="mute ? '' : 'unmute'" @click="toggleMute"></div> -->
                        <video 
                            v-if="slide.slide_image.includes('mov')" 
                            preload="auto" 
                            autoplay 
                            playsinline 
                            loop 
                            muted 
                            :src="slide.slide_image" 
                            type="video/quicktime">
                        </video>

                        <video 
                            v-if="slide.slide_image.includes('mp4')" 
                            preload="auto" 
                            autoplay 
                            playsinline 
                            loop 
                            muted 
                            :src="slide.slide_image" 
                            type="video/mp4">
                        </video>
                        <figcaption>
                            <span>
                                <div class="show-slug" v-if="showRoute !== 'home' && showRoute !== 'london'" ><span class="sans-serif uppercase letter-space2">{{ showRoute }}</span></div>
                                <h2><a :href="slide.slide_link" class="">{{ slide.slide_title }}</a></h2>
                                <p>{{ slide.slide_description }}</p>
                                <button v-if="slide.slide_link_label"><a :href="slide.slide_link" class="">{{  slide.slide_link_label }}</a></button>
                                <div v-if="showRoute == 'journal'" class="meta uppercase letter-space2">
                                    <div v-for="journal in journals" :key="journal.journal.slug">
                                        <span v-if="(getSlugFromUrl(slide.slide_link) === journal.journal.slug)">
                                                <span>{{ formatDate(journal.journal.date) }}</span>
                                                <strong style="padding: 0 10px;">&#8226;</strong>
                                                <span>{{ calculateReadingTime(journal.journal.content) }} MIN READ</span>
                                        </span>
                                    </div>
                                </div>
                            </span>
                        </figcaption>
                    </figure>
                </div>
            </div>
            <!-- <div style="width: 100%; text-align: center; display: inline-block; height: 0;"> -->
            <div class="bullets-wrapper">
                <ul class="bullets">
                    <!-- <li v-for="(slide,i) in slides" @click="selectSlide(i)" v-html="i==current ? '.' : '.'" :class="i==current ? 'current' : ''"></li> -->
                    <li v-for="(slide,i) in slides" @click="selectSlide(i)" :class="i==current ? 'current' : ''"></li>
                </ul>
            </div>
    
            <!-- <a class="prev" href="#" @click.prevent="prevSlide">&#x25C0;</a>
            <a class="next" href="#" @click.prevent="nextSlide">&#x25B6;</a> -->
    
        </div>
        <div class="progress-container">
            <div  class="progress-bar"></div>
        </div>
    </div>

</template>
    
<style lang="scss">

    .progress-bar {
        width: 100%;
        animation: progress-animation 7500ms linear forwards;
    }
    .theslides h2 {
        width: calc(100vw - 75px);
    }
    @keyframes progress-animation {
        0% {
            width: 100%;
        }
        100% {
            width: 0%;
        }
    }

</style>

<script>
    export default {
        name: "slider",
        props: ['journals'],
        data() {       
            return {
                slides: [],
                current: 0,
                width: 100,
                reset: false,
                mute: true,
                url: this.url,
                showRoute: this.showRoute,
            };
        },
        methods: {
            getSlider(address) {
                return new Promise((resolve, reject) => {
                     this.$axios.get(address ? address : "/api/slider" ).then(response => {
                    var pageSlug = this.showRoute;
                    if (this.showRoute == 'home' || this.showRoute == 'london') {
                        this.slides = response.data.data[0].Slides;
                    } if (this.showRoute == 'journal') {
                        this.slides = response.data.data[1].Slides;
                    }
                    resolve(this.slides); // Resolve with the slides
                    }).catch(error => {
                        reject(error);
                    });
                    });
                },
                
            getSlugFromUrl(url) {
            const slug = url.split('/').pop();
            return slug;
            },
            formatDate(dateString) {
                const date = new Date(dateString)
                return date.toLocaleString('default', { month: 'long', year: 'numeric' })
                },
            calculateReadingTime(articleText) {
                if (!articleText) {
                    return 0;
                }
                let wordCount = articleText.split(' ').length;
                let wordsPerMinute = 200;
                let readingTime = Math.ceil(wordCount / wordsPerMinute);
                return readingTime;
                },
                
            nextSlide: function() {
                this.current++;
                if (this.current >= this.slides.length)
                    this.current = 0;
                this.resetPlay();
            },
            prevSlide: function() {
                this.current--;
                if (this.current < 0)
                    this.current = this.slides.length - 1;
                this.resetPlay();
            },
            selectSlide: function(i) {
                this.current = i;
                this.resetPlay();
            },
            resetPlay: function() {
                clearInterval(this.timer);
                
                const progressElement = document.querySelector('.progress-bar');
                
                if (progressElement) {
                    progressElement.style.animation = 'none';
                    progressElement.offsetHeight; // Trigger reflow
                    progressElement.style.animation = null;
                }
                
                this.play(); // Start the slide change timer

                const videoElements = document.querySelectorAll("video");
                videoElements.forEach((videoElement) => {
                    videoElement.currentTime = 0; // Reset video to the start

                    // Ensure the video is muted
                    videoElement.muted = this.mute; 

                    videoElement.addEventListener('play', () => {
                        console.log('Video is playing');
                    });
                    videoElement.addEventListener('error', (e) => {
                        console.error('Video playback error:', e);
                    });

                    // Only attempt to play if the video is visible
                    const isVisible = this.isElementInViewport(videoElement); // Add a method to check visibility
                    if (isVisible) {
                        videoElement.load(); // Reload the video
                        videoElement.play().catch((error) => {
                            console.error("Error in resetPlay while trying to play video:", error);
                        });
                    }
                });

                if (this.timeElapsed !== 0) this.timeElapsed = 0;
            },

            isElementInViewport(el) {
                const rect = el.getBoundingClientRect();
                return (
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            },


            // Method to play/pause video based on visibility
            handleVisibility(entries) {
                entries.forEach(entry => {
                    const videoElement = entry.target;
                    if (entry.isIntersecting) {
                        videoElement.play().catch((error) => {
                            console.error("Error playing video:", error);
                        });
                    } else {
                        videoElement.pause();
                    }
                });
            },

            play() {
                const app = this;
                this.timer = setInterval(function() {
                    app.nextSlide();
                }, 7500);
            },


            toggleMute() {
                this.mute = !this.mute
            },
        },
        computed: {   
            widthTransform() {
                const xValue = this.current * 100;
                return {
                    transform: 'translateX(-' + xValue + 'vw)',
                    '-webkit-transform': 'translateX(-' + xValue + 'vw)',
                    '-moz-transform': 'translateX(-' + xValue + 'vw)',
                    '-ms-transform': 'translateX(-' + xValue + 'vw)',
                };
            },
        },

        watch: {
            '$route.name': function () {
            this.showRoute = this.$route.name;
            },    
        },

        async created() {
            this.url = window.location.origin;
            this.showRoute = this.$route.name;
            try {
            await this.getSlider();
            if (this.slides.length > 0) {
                this.play(); 
            }
            } catch (error) {
           console.error('Error fetching slides:', error);
            }
        },
        mounted() {
            // Set up the Intersection Observer
            this.observer = new IntersectionObserver(this.handleVisibility);
            
            const videoElements = document.querySelectorAll("video");
            videoElements.forEach(video => {
                this.observer.observe(video);
            });
        },
        beforeDestroy() {
            // Clean up the observer
            if (this.observer) {
                this.observer.disconnect();
            }
        }
    }
    </script>
